import { useApp } from "@/hooks/use-app";
import { toastVariant, type ToastVariantProps } from "./toast.variants";

export type UseToastProps = ToastVariantProps & {
  className?: string;
  style?: Record<string, string | number>;
};

export const useToast = (props: UseToastProps) => {
  const { className = "", ...componentProps } = props;
  const {
    state: { toast },
    onToastChange,
  } = useApp();

  const styles = toastVariant();

  return {
    className,
    styles,
    componentProps,
    isOpen: toast?.open,
    message: toast?.message,
    type: toast?.type,
    onToastChange,
  };
};
